import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  CircularProgress,
  Container,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CustomBreadcrumbs from "../../../common/components/breadcrumb-component-new/breadcrumb-component-new";
import ReviewsComponent from "./ReviewsComponent";
import {
  getProviderDetailsById,
  getProviderReviewsById,
} from "../../../api/details-page.api";
import MobileHeader from "../../../common/components/mobile-header-component/MobileHeader";
import { useNavigate } from "react-router-dom";
import { ProviderDetailsAccordion } from "../details-page.types";

interface Review {
  id: number;
  user: {
    id: number;
    first_name: string;
    last_name?: string;
  };
  createdAt: string;
  description: string;
  rating: number;
}

const ReviewsPage = () => {
  const { id } = useParams<{ id: string }>();
  const [reviews, setReviews] = useState<Review[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [providerDetails, setProviderDetails] =
    useState<ProviderDetailsAccordion | null>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const fetchReviews = async () => {
    try {
      setLoading(true);
      const storedLocation = localStorage.getItem("user_location");
      let latitude = null;
      let longitude = null;

      if (storedLocation) {
        const loc = JSON.parse(storedLocation);
        latitude = loc.latitude;
        longitude = loc.longitude;
      }
      const detailsResponse = await getProviderDetailsById(Number(id), {
        userLat: latitude,
        userLng: longitude,
      });

      if (detailsResponse.data.success) {
        const data = detailsResponse.data.data as ProviderDetailsAccordion;
        setProviderDetails(data);
      }

      const reviewsResponse = await getProviderReviewsById(Number(id));
      if (reviewsResponse.data.success) {
        const reviewsData = reviewsResponse.data.data.data || [];
        setReviews(reviewsData);
      }
    } catch (error) {
      console.error("Error refreshing reviews:", error);
    } finally {
      setLoading(false);
    }
  };

  const onReviewDeleted = () => {
    fetchReviews();
  };

  useEffect(() => {
    fetchReviews();
  }, [id]);

  if (loading) {
    return (
      <Box className="spinner-details-page">
        <CircularProgress
          size="3rem"
          className="spinner-details-page__spinner"
        />
      </Box>
    );
  }

  return (
    <>
      {isMobile && (
        <MobileHeader
          title="Reviews"
          onBack={() => navigate(-1)}
          className="custom-header"
          style={{ backgroundColor: "#f8f9fa" }}
        />
      )}
      <Container className="details-page">
        {!isMobile && (
          <CustomBreadcrumbs
            items={[
              { label: "Home", to: "/home" },
              { label: "List", to: "/home/list-of-funeral-homes" },
              { label: "Detail page", onClick: () => navigate(-1) },
              { label: "Customer Review" },
            ]}
          />
        )}
        {reviews.length > 0 ? (
          <ReviewsComponent
            reviews={reviews}
            totalReviews={providerDetails?.totalReviews || 0}
            rating={providerDetails?.avgRating || 0}
            isMobile={isMobile}
            partnerId={Number(id)}
            onReviewSubmitted={fetchReviews}
            fromReviewsPage={true}
            onReviewDeleted={() => {
              onReviewDeleted();
            }}
          />
        ) : (
          <Box textAlign="center" mt={4}>
            No reviews found.
          </Box>
        )}
      </Container>
    </>
  );
};

export default ReviewsPage;
